const config = (<any>window).appConfig

export default config;
